<template>
  <app-base-main
      no-padding
      adaptParent
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          :reset="false"
          :query="false">
        <gj-select
            v-if="false"
            :options="[]"
            placeholder="广告活动状态"
            width="120px"
        ></gj-select>
        <gj-select
            v-if="false"
            :options="[]"
            placeholder="状态"
            width="120px"
        ></gj-select>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="数据时间"
            :clearable="false"
            :max-day-length="180"
            @input="$gjNoticeQuery"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-checkbox
          v-model="filter.filterAdZero"
          @input="$gjNoticeQuery">
        <span style="color: #666">过滤广告业绩为0的数据</span>
      </gj-checkbox>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="asinAdPlacementAnalysis"
          :data="tableData"
          :columns="columns"
          :loading="loading"
          expand
          show-summary
          :summary-object="summaryData"
          :show-overflow="false"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:placement="{row}">
          {{row.placement | optionText(AdPlacementEnum.SP.placementAliasOption)}}
        </template>
        <template v-slot:expand:placement="{row}">
          <el-row v-gutter="8">
            <app-ad-route-link
                :market-id="row.marketId"
                :type="AdTypeEnum.SP"
                :campaign="row">
              {{row.campaignName}}
            </app-ad-route-link>
            <span>[ {{row.targetingType | optionText(AdCampaignEnum.SP.targetingTypeOption)}} ]</span>
            <span>{{row.bidStrategy | optionText(AdPlacementEnum.SP.bidStrategyOption)}}</span>
          </el-row>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>

  import {adFields} from "../../../common/fields";
  import {adDefaultSortMixin, adTypeRouteMixin, currencySymbolMixin} from "../../../common/mixin";
  import {queryMixin} from "../../../../../../minxins";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {isMeaningful} from "../../../../../../utils/common";
  import {
    getAdsAsinPerformancePlacement,
    getAdsAsinPerformancePlacementItems
  } from "../../../../../../api/ad";
  import {AdCampaignEnum, AdPlacementEnum, AdTypeEnum} from "../../../common/enum";
  import {defaultShow} from "../../../../../../filters";
  import AppAdRouteLink from "../../../common/components/app-ad-route-link";

  export default {
    name: "app-asin-placement-analysis",
    components: {AppAdRouteLink},
    mixins: [queryMixin, adTypeRouteMixin, currencySymbolMixin, adDefaultSortMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      },
      queryDate: {
        required: true
      }
    },
    created() {
      this.filter.date = this.queryDate;
      /*this.sort.prop = 'impressions';*/
    },
    data() {
      return {
        tableData: [],
        summaryData: [],
        columns: [
          {...adFields.placement, field: 'slot:placement', width: '300px'},
          {...adFields.impressions, sortable: false},
          {...adFields.clicks, sortable: false},
          {...adFields.ctr, sortable: false},
          {...adFields.cost, sortable: false},
          {...adFields.cpc, sortable: false},
          {...adFields.orders, sortable: false},
          {...adFields.cvr, sortable: false},
          {...adFields.cpa, sortable: false},
          {...adFields.sales, sortable: false},
          {...adFields.acos, sortable: false},
          
        ],
        filter: {
          filterAdZero: false,
          date: null
        },
        AdPlacementEnum: AdPlacementEnum,
        AdCampaignEnum: AdCampaignEnum,
        AdTypeEnum: AdTypeEnum
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          marketId: this.marketId,
          dataType: this.filter.filterAdZero ? 1 : 0,
          // status: this.filter.state,
          msku: this.item.msku,
          startDate: convertToDate(this.filter.date[0]),
          endDate: convertToDate(this.filter.date[1]),
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getAdsAsinPerformancePlacement(params)
          .then((data) => {
            if (isMeaningful(data) && data.length > 0) {
              this.summaryData = data.pop();
              this.tableData = this.currencySymbolMixin(data, this.currencySymbol);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      expandLazyLoad(row, index, resolve) {
        getAdsAsinPerformancePlacementItems({
          ...this.globalParams,
          placement: row.placement
        })
          .then((data) => {
            resolve(this.currencySymbolMixin(data || [], this.currencySymbol));
          })
          .catch(() => {
            resolve([]);
          });
      },
      spanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      },
      summaryMethod() {
        if (this.summaryData) {
          return [
            '',
            '总计',
            this.summaryData.impressions,
            this.summaryData.clicks,
            defaultShow(this.summaryData.ctr, '', '%'),
            defaultShow(this.summaryData.cost, this.currencySymbol, ''),
            defaultShow(this.summaryData.cpc, this.currencySymbol, ''),
            this.summaryData.adsOrders,
            defaultShow(this.summaryData.adsSales, this.currencySymbol, ''),
            defaultShow(this.summaryData.acos, '', '%', ''),
            defaultShow(this.summaryData.cvr, '', '%', ''),
            defaultShow(this.summaryData.cpa, this.currencySymbol, '', ''),
          ]
        } else {
          return [];
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .gj-table .gj-help--icon .gj-icon{
  color: #999999;
}
 /deep/ .table{
   flex: 1;
   overflow: auto;
 }
</style>

